import { AppInsights } from 'applicationinsights-js'
import { configuration } from '../rest-api/Configuration'
import { IMonitoringService } from './IMonitoringService'

export class MonitoringService implements IMonitoringService {
  constructor() {
    const key = configuration.ApplicationInsightsKey
    if (key && AppInsights.downloadAndSetup) {
      AppInsights.downloadAndSetup({
        instrumentationKey: key
      })
    }
  }

  public logPageView(
    name?: string,
    url?: string,
    properties?: {},
    measurements?: {},
    duration?: number
  ) {
    if (AppInsights) {
      AppInsights.trackPageView(name, url, properties, measurements, duration)
    }
  }

  public logEvent(name: string, properties?: {}, measurements?: {}) {
    if (AppInsights) {
      AppInsights.trackEvent(name, properties, measurements)
    }
  }
}

